import React, { useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { Card } from '../../../components/Card';
import { Pagination } from '../../../components/Pagination';
import { Table } from '../../../components/Table';
import { AdminH1 } from '../../components/AdminH1';
import { Button } from '../../../components/Button';

import { Paged } from '../../../types/common';
import queryString from 'query-string';
import { getPopUpTargetBranches } from '../../../api/popupTargetBranchAPI';
import { PopUpTargetBranch as PopUpTargetBranchDto } from '../../../types/popupTargetBranch';
import { MomentFormat, utcToLocalFormat } from '../../../plugins/moment';
import CopyToClipboard from 'react-copy-to-clipboard';
import { toast } from 'react-toastify';

export const PopUpTargetBranch = () => {
  const history = useHistory();
  const query = queryString.parse(history.location.search);
  const [popUpTargetBranches, setPopUpTargetBranches] = React.useState<
    Paged<PopUpTargetBranchDto>
  >({ items: [] });

  const getList = () => {
    let nQuery = ``;
    nQuery += `&order[id]=DESC`;
    getPopUpTargetBranches(`${nQuery}`, Number(query.page), Number(query.limit))
      .then((res) => setPopUpTargetBranches(res.data))
      .catch((err) => console.error(err.response));
  };

  useEffect(() => {
    getList();
  }, []);

  return (
    <>
      <AdminH1>팝업 문의 지점 관리</AdminH1>
      <div>
        <Button
          text="팝업 문의 지점 추가"
          className="filled-black h-12"
          to="/admin/popup/branch/add"
        />
      </div>

      <Card>
        <Table>
          <Table.Head>
            <Table.Row>
              <Table.Th>등록일자</Table.Th>
              <Table.Th>지점명</Table.Th>
              <Table.Th>URL</Table.Th>
              <Table.Th></Table.Th>
            </Table.Row>
          </Table.Head>
          <Table.Body>
            {popUpTargetBranches.items.length === 0 && (
              <Table.Row>
                <Table.Td colSpan={4}>데이터가 없습니다.</Table.Td>
              </Table.Row>
            )}
            {popUpTargetBranches.items.map((branch, index) => (
              <Table.Row key={index}>
                <Table.Td>
                  {utcToLocalFormat(
                    branch.createdAt!.toLocaleString(),
                    MomentFormat.YYYYMMDDHmm
                  )}
                </Table.Td>
                <Table.Td>{branch.branchName}</Table.Td>
                <Table.Td>
                  <CopyToClipboard
                    text={`${process.env.REACT_APP_FRONT_URL}/popup/inquiry?branchId=${branch.id}`}
                    onCopy={() => toast.info('복사되었습니다.')}
                  >
                    <span className={'cursor-pointer text-blue-500 underline'}>
                      {`${process.env.REACT_APP_FRONT_URL}/popup/inquiry?branchId=${branch.id}`}
                    </span>
                  </CopyToClipboard>
                </Table.Td>
                <Table.Td className="text-right">
                  <Link
                    className="rounded-md font-normal text-indigo-600 hover:text-indigo-900"
                    to={`/admin/popup/branch/${branch.id}`}
                  >
                    상세보기
                  </Link>
                </Table.Td>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>

        <Pagination>
          <Pagination.Label
            count={popUpTargetBranches.items.length}
            total={popUpTargetBranches.pagination?.totalItemCount!}
          />
          <Pagination.Nav
            basePath="/admin/popup/branch"
            total={popUpTargetBranches.pagination?.totalItemCount!}
          />
        </Pagination>
      </Card>
    </>
  );
};
